import { render, staticRenderFns } from "./HomeClient.vue?vue&type=template&id=465a3a09&scoped=true&lang=pug"
import script from "./HomeClient.vue?vue&type=script&lang=js"
export * from "./HomeClient.vue?vue&type=script&lang=js"
import style0 from "./HomeClient.vue?vue&type=style&index=0&id=465a3a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a3a09",
  null
  
)

export default component.exports